import multiguard from 'vue-router-multiguard';
import { checkAuth } from '@/router/_auth';
import { checkBankType } from '@/router/corporate/_type';

export default [{
	path: '/home/corporate/profile',
	name: 'corporateProfile',
	redirect: { name: 'corporateProfileEdit' },
	meta: {
		title: 'Kurumsal İnternet Şube - Profil',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType]),
	component: () => import(/* webpackChunkName: "corporateProfile" */ '@/views/corporate/profile/Home.vue'),
	children: [
		{
			path: 'me',
			name: 'corporateProfileEdit',
			meta: {
				title: 'Profil Bilgileri ',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "corporateProfile" */ '@/views/corporate/profile/me/Home.vue'),
		},
		{
			path: 'company',
			name: 'corporateProfileCompany',
			meta: {
				title: 'Şirket Bilgileri ',
				layout: 'default'
			},
			component: () => import(/* webpackChunkName: "corporateProfile" */ '@/views/corporate/profile/company/Home.vue'),
		}
	]
},
{
	path: '/home/corporate/profile/me/phone',
	name: 'corporateProfileMePhone',
	meta: {
		title: 'Kurumsal İnternet Şube - Profil',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType]),
	component: () => import(/* webpackChunkName: "corporateProfile" */ '@/views/corporate/profile/me/Phone.vue'),
},
{
	path: '/home/corporate/profile/me/mail',
	name: 'corporateProfileMeMail',
	meta: {
		title: 'Kurumsal İnternet Şube - Profil',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType]),
	component: () => import(/* webpackChunkName: "corporateProfile" */ '@/views/corporate/profile/me/Mail.vue'),
},
{
	path: '/home/corporate/profile/me/name',
	name: 'corporateProfileMeName',
	meta: {
		title: 'Kurumsal İnternet Şube - Profil',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType]),
	component: () => import(/* webpackChunkName: "corporateProfile" */ '@/views/corporate/profile/me/Name.vue'),
},
{
	path: '/home/corporate/profile/user/edit/:id',
	name: 'corporateProfileUserEdit',
	meta: {
		title: 'Kurumsal İnternet Şube - User Edit',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType]),
	component: () => import(/* webpackChunkName: "corporateProfile" */ '@/views/corporate/profile/users/Edit.vue'),
},
{
	path: '/home/corporate/profile/user/new',
	name: 'corporateProfileNewUser',
	meta: {
		title: 'Kurumsal İnternet Şube - New User',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType]),
	component: () => import(/* webpackChunkName: "corporateProfile" */ '@/views/corporate/profile/users/New.vue'),
},
{
	path: '/home/corporate/profile/company/address',
	name: 'corporateCompanyAddressEdit',
	meta: {
		title: 'Kurumsal İnternet Şube - Address Edit',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType]),
	component: () => import(/* webpackChunkName: "corporateProfile" */ '@/views/corporate/profile/company/Address.vue'),
},
{
	path: '/home/corporate/profile/company/city',
	name: 'corporateCompanyCityEdit',
	meta: {
		title: 'Kurumsal İnternet Şube - City Edit',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType]),
	component: () => import(/* webpackChunkName: "corporateProfile" */ '@/views/corporate/profile/company/City.vue'),
},
{
	path: '/home/corporate/profile/company/district',
	name: 'corporateCompanyDistrictEdit',
	meta: {
		title: 'Kurumsal İnternet Şube - District Edit',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType]),
	component: () => import(/* webpackChunkName: "corporateProfile" */ '@/views/corporate/profile/company/District.vue'),
},
{
	path: '/home/corporate/profile/company/email',
	name: 'corporateCompanyEmailEdit',
	meta: {
		title: 'Kurumsal İnternet Şube - Email Edit',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType]),
	component: () => import(/* webpackChunkName: "corporateProfile" */ '@/views/corporate/profile/company/Email.vue'),
},
{
	path: '/home/corporate/profile/company/phone',
	name: 'corporateCompanyPhoneEdit',
	meta: {
		title: 'Kurumsal İnternet Şube - Phone Edit',
		layout: 'default'
	},
	beforeEnter: multiguard([checkAuth, checkBankType]),
	component: () => import(/* webpackChunkName: "corporateProfile" */ '@/views/corporate/profile/company/Phone.vue'),
}
]